"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngineerAggregator = void 0;
const EngineerAggregatorType_1 = require("./EngineerAggregatorType");
class EngineerAggregator {
    constructor(year, month) {
        this.aggregators = new Map();
        this.aggregators.set(EngineerAggregatorType_1.EngineerAggregatorType.ALL, () => [""]);
        this.aggregators.set(EngineerAggregatorType_1.EngineerAggregatorType.ENGINEER, (engineer) => (engineer.id ? [engineer.id] : []));
        this.aggregators.set(EngineerAggregatorType_1.EngineerAggregatorType.TEAM, (engineer) => {
            return engineer.getTeamIds(year, month);
        });
        this.aggregators.set(EngineerAggregatorType_1.EngineerAggregatorType.SKILL, (engineer) => {
            return engineer.skills ? engineer.skills : [];
        });
        this.aggregators.set(EngineerAggregatorType_1.EngineerAggregatorType.REGION, (engineer) => {
            return engineer.region ? [engineer.region] : [];
        });
    }
    get(engineer, type) {
        const fn = this.aggregators.get(type);
        return fn(engineer);
    }
}
exports.EngineerAggregator = EngineerAggregator;
//# sourceMappingURL=EngineerAggregator.js.map